<template>
	<div id="common" style="background-color: #f2f2f2;">
		
		<el-container>
			<!-- 头部 -->
			<el-header style="height: 10rem;">
				<div class="header">
					<div class="header-div">
						<div class="left">
							<img :src="avatar" />
							<div class="div">
								<div class="div1">{{info.username}}</div>
								<div class="div2">{{info.brief}}</div>
								<!-- <div class="div2">
									<div>
										<img src="http://jinbangsai.net/shudu/images/%E7%94%A8%E6%88%B7%E4%B8%AD%E5%BF%83-%E8%B5%84%E6%96%99%E8%AE%BE%E7%BD%AE/u21.png" />
										<span>中国|杭州</span>
									</div> 
									<div>
										<img src="http://jinbangsai.net/shudu/images/%E7%94%A8%E6%88%B7%E4%B8%AD%E5%BF%83-%E8%B5%84%E6%96%99%E8%AE%BE%E7%BD%AE/u20.png" />
										<span>最强大脑第四季选手</span>
									</div>
								</div> -->
							
							</div>
							
						</div>
						<div class="right">
							<div class="right1">
								<div class="right2">
									<div>{{info.attention ? info.attention: 0 }}</div>
									<div>粉丝</div>
								</div>
								
								<div class="right2">
									<div>{{info.visitor ? info.visitor: 0 }}</div>
									
									<div>访客</div>
								</div>
							</div>
							
							<div class="right3" v-if="types<=0" @click="visitorClick()">关注</div>
							<div class="right3" v-if="types>0" @click="visitorClick()" >已关注</div>
							
						</div>
						
					</div>
					<div class="tab">
					<!-- 	<div @click="url('/author_question')" :class="type=='/author_question' ? 'action':''">赛事</div> -->
						<div @click="url('/author_question')" :class="type=='/author_question' ? 'action':''">题型</div>
						<div  @click="url('/author_bank')" :class="type=='/author_bank' ? 'action':''">题库</div>
						
						<div @click="url('/author_article')" :class="type=='/author_article' ? 'action':''">文章</div>
						<div @click="url('/author_books')" :class="type=='/author_books' ? 'action':''">推荐书籍</div>
					</div>
				</div>
			</el-header>  
			<div style="height: 1rem;"></div>
			<el-container style="width: 80%;  margin: auto; padding-bottom:6rem">
				
				
				<el-main>
					
					
					<router-view></router-view>   
				</el-main>
			</el-container>
		</el-container>
		
	</div>
	
	


</template>

<script>
	export default {
	    data() {
			return {
				type: '/author_question',
				sponsor_id : '',
				types : '',
				avatar  : ''
			}
	    },
		created() {
			let that = this;
			var  query = that.$route.query;
			that.type  = this.$route.path;
			// console.log( this.$route.path);
			if(query.sponsor_id){
				that.sponsor_id = query.sponsor_id;
				that.infoTpye();
				
				that.$http('post','/api/v1/sponsor/add',{sponsor_id:that.sponsor_id,type:1}) .then(function (res) {
					
				});
			}
		},
		methods:{
			url(e){
				var url   =  e+'?sponsor_id='+this.sponsor_id;
				this.$router.push(url);
				this.type = e;
			},
			infoTpye(){
				let that =this;
				that.$http('get','/api/v1/sponsor/info?sponsor_id='+that.sponsor_id,{}) .then(function (res) {
					that.info = res.data.info;
					that.types = res.data.type;
					that.avatar = res.data.info.avatar;
					console.log(that.info);
				});
			},
			visitorClick(){
				let that =this;
				that.$http('post','/api/v1/sponsor/add',{sponsor_id:that.sponsor_id,type:0}) .then(function (res) {
					that.$message({message: res.msg,type: 'success'});
					that.infoTpye();
				});
			},
			
		},
	}
	
</script>

<style lang="less">
	.el-header {
		height: 10rem;
		padding: 0;
	}
	.lefttype {
		color: #3d3e40 !important;
		font-size: 0.86rem !important;
	}
	.header {
		color: #FFFFFF;
		background-color: rgba(9, 7, 35, 1);
		width: 100%;
		height: 10rem;
		.header-div {
			width: 70%;
			margin: auto;
			display: flex;
			padding-top: 2rem;
			.left {
				flex: 2;
				display: flex;
				img {
					width: 5rem;
					border-radius: 3.125rem;
				}
				.div {
					padding-left: 1.6rem;
					.div1 {
						font-size: 1rem;
						font-weight: 600;
						padding-top: 1rem;
					}
					.div2 {
						padding-top: 0.6rem;
						font-size: 0.6rem;
						display: flex;
						width: 600px;
						padding-right: 20px;
						 overflow: hidden;
						          text-overflow: ellipsis;
						          display: -webkit-box;
						          -webkit-line-clamp: 3; //行数
						          -webkit-box-orient: vertical;
						height: 30px;
						padding-right: 20px;
						div {
							
							img {
								width: 1rem;
								position: relative;
								top: 0.2rem;
							}
							span {
								padding-left: 0.4rem;
							}
						}
						div:nth-last-child(1){
							margin-left: 0.6rem;
						}
						
					}
					.div3 {
						position: relative;
						top: 1rem;
						font-size: 0.6rem;
					}
				}
				
			}
			.right {
				flex: 1;
				padding-top: 1.4rem;
				.right1 {
					display: flex;
					font-size: 0.6rem;
					.right2 {
						width: 2rem;
						text-align: center;
						line-height: 1.2rem;
					}
				}
				.right3 {
					position: relative;
					top: 0.8rem;
					left: 0.3rem;
					width: 5.4rem;
					text-align: center;
					height: 1.6rem;
					background-color: #FFFFFF;
					color: #000000;
					line-height: 1.6rem;
					border-radius: 0.4rem;
					font-size: 0.6rem;
				}
				
			}
		}
		.tab {
			display: flex;
			width: 50%;
			margin: auto;
			margin-top: 1rem;
			div {
				color: #A4A1A6;
				margin-left: 0.5rem;
				margin-right: 0.5rem;
				height: 1.4rem;
			}
			.action {
				border-bottom: 0.2rem solid rgba(217, 0, 27, 1);
			}
		}
	}
	.el-aside {
		margin-left: 1rem;
		height:23.5rem;
		div {
			font-size: 0.6rem;
			width: 100%;
			height: 2rem;
			line-height: 2rem;
			border-bottom: 1px solid #e9e9e9 ;
			color: #7F7F7F;
		}
	}
	
</style>
